import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { User } from 'modules/domain/user/types'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { CommonFields } from './CommonFields'

type Props = {
  setShowModal: () => void
  refetch: () => void
  user: User
}

type Fields = {
  full_name: string | null
  position: string | null
  phone: string | null
  is_mobile_phone: boolean
}

export const AddContactModal: FC<Props> = ({ setShowModal, user, refetch }) => {
  const { formProgress, formHandler } = useAFormHandler()

  const formik = useFormik<Fields>({
    initialValues: {
      full_name: null,
      position: null,
      phone: null,
      is_mobile_phone: false,
    },
    onSubmit: formHandler(
      async () => {
        await apiClient.post(endpoints.userContacts(user.id), { ...formik.values })
      },
      {
        onSuccess: async () => {
          await refetch()
          setShowModal()
        },
        onError: (error) => {
          const { errors } = error
          formik.setErrors(errors)
        },
      },
    ),
  })

  return <CommonFields id="AddContactModal" formik={formik} setShowModal={setShowModal} progress={formProgress} />
}
